exports.countryCodeNL = "nl";
exports.countryCodeBE = "be";
exports.countryCodeDE = "de";
exports.defaultPollingInterval = 180000;

exports.echeckScannerDelta = 150; //ms
exports.echeckMinimumBarcodeLength = 1;

exports.stockhubReturnPreCode = "STOCKHUBRTPH";
exports.stockhubInboundPreCode = "STOCKHUBIBPH";